import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { BusinessDetails, Transactions, Invoices } from '/components'

function TabContainer(props) {
  return (
    <div style={{ padding: 20 }}>
      {props.children}
    </div>
  );
}

const styleSheet = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
    marginTop: theme.spacing.unit * 3,
  },
  paper: {
    padding: 16
  }
});

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { value: 0 };
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render = () => {
    const classes = this.props.classes;

    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="Business details" />
            <Tab label="Transactions" />
            <Tab label="Invoices" />
          </Tabs>
        </AppBar>
        <SwipeableViews index={this.state.value} onChangeIndex={this.handleChangeIndex}>
          <TabContainer>
            <BusinessDetails />
          </TabContainer>
          <TabContainer>
            <Transactions />
          </TabContainer>
          <TabContainer>
            <Invoices />
          </TabContainer>
        </SwipeableViews>
      </div>
    )
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js